import React, { Component } from 'react';
import style from './index.css';

interface IProps {
    title: String;
}
export default class Title extends Component<IProps> {
    public render() {
        const { title } = this.props;
        return <React.Fragment>
            <div className={style['add-items-title']}>{title}</div>
        </React.Fragment>;
    }
}
